import { useContext, useMemo } from 'react';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { TOUR_TO_FINISH_OPTIONS } from './onboardingTourConfig';
import { getOnboardingDisabledInSelenium } from '../../utils/localStorage';
const useOnboardingTour = () => {
  const {
    tour
  } = useContext(TourContext);
  const tourSteps = useMemo(() => tour.getConfig().steps, [tour]);
  const tourName = useMemo(() => tour.getTour(), [tour]);
  return useMemo(() => ({
    tourName,
    tourSteps,
    startTour: key => {
      if (getOnboardingDisabledInSelenium()) {
        return;
      }
      tour.start(key);
    },
    finishTour: () => tour.finish(true),
    getIsLastStep: () => tour.getStep() === tourSteps[tourSteps.length - 1],
    nextStep: () => tour.next(),
    finishOptions: tourName && TOUR_TO_FINISH_OPTIONS[tourName] || {}
  }), [tour, tourName, tourSteps]);
};
export default useOnboardingTour;